import { ClientListItem } from 'src/admin/users/types';
import { matchesClientSearch } from 'src/utils/clientSearch';

/**
 * The clients that can still be added as an item's owner from the client list, matching the
 * search. Owners need not share a family, so this is every client the viewer can open apart from
 * those already offered or chosen.
 */
export const ownerCandidates = (
  clients: ClientListItem[],
  excludedClientIds: Set<string>,
  search: string,
): ClientListItem[] =>
  clients.filter(
    client =>
      !excludedClientIds.has(client.id) &&
      matchesClientSearch([client.firstName, client.lastName, client.emailAddress], search.trim()),
  );
